import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState } from 'recompose';
import { Field, reduxForm } from 'redux-form';
import { ui } from 'components';
import HOCs from 'components/HOCs';
import { required, email } from 'validators';

import './style.scss';

const FORM_NAME = 'selfPickUpForm';

const SelfPickUpForm = ({
  handleSubmit,
  isChecked,
  setIsChecked,
}) => (
  <form onSubmit={handleSubmit} className="selfpickup-form">
    <div className="deliveryservice-form__row">
      <div className="deliveryservice-form__column">
        <Field
          component={ui.Fields.BaseField}
          name="name"
          validate={[required]}

          props={{
            label: 'Фамилия, Имя',
          }}
        />
        <Field
          component={ui.Fields.BaseField}
          name="phone"
          validate={[required]}

          props={{
            label: 'Контактный телефон',
          }}
        />
        <Field
          component={ui.Fields.BaseField}
          name="email"
          validate={[required, email]}

          props={{
            label: 'E-mail',
          }}
        />
      </div>
    </div>
    <div className="selfpickup-form__row selfpickup-form__accept">
      <input
        id="agreement"
        className="selfpickup-form__checkbox"
        type="checkbox"
        checked={isChecked}
        onClick={() => {
          setIsChecked(!isChecked);
        }}
      />
      <label
        htmlFor="agreement"
        className="selfpickup-form__label"
      >
        Настоящим я подтверждаю, что ознакомлен с <a className="selfpickup-form__link" rel="noopener noreferrer" target="_blank" href="http://shop.yartf.ru/assets/politika_obrabotki_pers_dannih.pdf">Политикой обработки персональных данных</a> и
        даю свое согласие на обработку персональных данных в целях совершения покупки
        в интернет-магазине shop.yartf.ru, ознакомлен с <a className="selfpickup-form__link" rel="noopener noreferrer" target="_blank" href="http://shop.yartf.ru/assets/dogovor_publicnoi_oferti.pdf">Договором публичной оферты</a> и согласен с его условиями
      </label>
    </div>
    <div className="selfpickup-form__button">
      <ui.Buttons.BaseButton
        style={{
          fontSize: 12,
        }}
        disabled={!isChecked}
        title="сформировать заказ"
      />
    </div>
  </form>
);

SelfPickUpForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  setIsChecked: PropTypes.func.isRequired,
};

export default compose(
  HOCs.FormErrorsHandlerHOC(),
  withState('isChecked', 'setIsChecked', false),

  reduxForm({
    form: FORM_NAME,
  }),
)(SelfPickUpForm);



// WEBPACK FOOTER //
// ./src/components/forms/SelfPickUpForm/index.js